<div class="back-button" (click)="goBack()"><app-icon iconName="arrow-left"></app-icon></div>